import { useContext } from "react";
import { AppContext } from "../../../contexts/AppContext";
import { Link } from "react-router-dom";
import { LoadingContent } from "../Shared/LoadingContent";

export type DynamicPositionFiltersProps = {
    redirectToPositionList: boolean
}

export function DynamicPositionFilters(props: DynamicPositionFiltersProps) {
    const app = useContext(AppContext);

    const linkButtons = app?.positions?.SettingLinks?.map(x => {
        return <a key={`PLF_SL_${x.Name}`} className="flex-fill list-group-item list-group-item-action" target="_blank" style={{ width: 'auto' }} href={x.URL}>{x.Name}</a>
    })

    let departmentButtons: JSX.Element[] = null;
    let roleButtons: JSX.Element[] = null;
    let locationButtons: JSX.Element[] = null;
    let categoryButtons: JSX.Element[] = null;

    if (app.positions?.Features.JobBoard_GenerateDepartmentLinks) {
        departmentButtons = app.positions?.Departments.filter(x => x != "Unspecified").map(x => { return <Link onClick={() => document.getElementById("close-lefthand-menu")?.click()} key={`PLF_D_${x}`} className="flex-fill list-group-item list-group-item-action" style={{ width: 'auto' }} to={`${props.redirectToPositionList ? `\\` : ""}?d=${x}`}>{x}</Link> })
    }

    if (app.positions?.Features.JobBoard_GenerateRoleLinks) {
        locationButtons = app.positions?.Locations.filter(x => x != "Unspecified").map(x => { return <Link onClick={() => document.getElementById("close-lefthand-menu")?.click()} key={`PLF_R_${x}`} className="flex-fill list-group-item list-group-item-action" style={{ width: 'auto' }} to={`${props.redirectToPositionList ? `\\` : ""}?l=${x}`}>{x}</Link> })
    }

    if (app.positions?.Features.JobBoard_GenerateLocationLinks) {
        roleButtons = app.positions?.Roles.filter(x => x != "Unspecified").map(x => { return <Link onClick={() => document.getElementById("close-lefthand-menu")?.click()} key={`PLF_L_${x}`} className="flex-fill list-group-item list-group-item-action" style={{ width: 'auto' }} to={`${props.redirectToPositionList ? `\\` : ""}?r=${x}`}>{x}</Link> })
    }

    if (app.positions?.Features.JobBoard_GenerateCategoryLinks) {
        categoryButtons = app.positions?.JobCategories.map(x => { return <Link onClick={() => document.getElementById("close-lefthand-menu")?.click()} key={`PLF_JCC_${x.Name}`} className="flex-fill list-group-item list-group-item-action" style={{ width: 'auto' }} to={`${props.redirectToPositionList ? `\\` : ""}?jcc=${x.Code}`}>{x.Name}</Link> })
    }
    
    return (<>
        <LoadingContent loading={app.loading} classes="w-100 d-flex justify-content-center">
            <ul className="list-group flex-column flex-lg-row flex-wrap list-group-flush dt-gap-2 position-filters-and-links">
                {categoryButtons}
                {departmentButtons}
                {locationButtons}
                {roleButtons}
                {linkButtons}
            </ul>
        </LoadingContent>
    </>);
}